import { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { GetDahsboard, GetExecutor } from "../../api/get";
import Modal from "react-responsive-modal";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { AddExecutor, SaveExecutor } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Spinner from "../../Common/Spinner";
import Header from "../../Common/Header";
import Loader from "../../loader";
import { FaAngleLeft } from "react-icons/fa6";
import { useFormik } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { FaInfoCircle } from "react-icons/fa";

const Executor = () => {
  const [executors, setExecutor] = useState([]);
  const [openModal, setOpenModal] = useState();
  const [loading, setLoading] = useState(false);
  const [contentLoder, setContentLoader] = useState(true);
  const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(false); // New state for Next button
  const [addButtonDisable, setaddButtonDisable] = useState(false);
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("dd/mm/yyyy");
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();
  const onCloseGuardianModel = () => {
    setOpenModal(false);
    formikAddGuardian.resetForm(); // Reset the form on modal close
  };
  useEffect(() => {
    GetExecutor()
      .then((res) => {
        setExecutor(res.data);
        setContentLoader(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  console.log("executors =>", executors);
  const formatDateToYMD = (dob) => {
    if (!dob || dob === "undefined" || dob.trim() === "") {
      return ""; // Return an empty string if the input is invalid
    }
    // Assuming `dob` is in "dd/mm/yyyy" format
    const [day, month, year] = dob.split("/");
    if (!day || !month || !year) {
      return ""; // Return empty if any part is missing
    }
    return `${year}-${month}-${day}`; // Convert to "yyyy-mm-dd"
  };
  const formik = useFormik({
    initialValues: {
      executors:
        executors.length > 0
          ? executors.map((b) => ({
              id: b.beneficiary_id || null,
              executor_type: b.executor_type,
              isSelected: b.is_selected || false,
            }))
          : [], // Handle empty state
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      executors: Yup.array().of(
        Yup.object({
          id: Yup.number().nullable(),
          isSelected: Yup.boolean(),
        })
      ),
    }),
    onSubmit: async (values) => {
      console.log("values =>", values);
      try {
        const save_executors = values.executors
          .filter((executor) => executor.isSelected)
          .map((executor) => ({
            executor_type: executor.executor_type,
            beneficiary_id: executor.id || null,
          }));

        const payload = { save_executors };
        console.log("payload =>", payload);
        SaveExecutor(payload)
          .then((res) => {
            if (res.success && res.status_code === "200") {
              toast.success("Executor Save Successfully");
              navigate("/dashboard");
            } else {
              if (res.status_code === "501") {
                toast.error(res.data.error);
              } else if (res.status_code === "422") {
                const errorMessages = Object.values(res.data.error)
                  .flat()
                  .join(", ");
                toast.error(errorMessages);
              }
            }
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            toast.error("An error occurred");
            console.log(err);
          });
      } catch (error) {
        console.error("API Error:", error);
      }
    },
  });
  console.log("formik =>", formik.values.executors);
  // Check if at least one checkbox is selected
  useEffect(() => {
    const hasSelected = formik.values.executors.some(
      (b) => b.isSelected === true
    );
    setIsNextButtonEnabled(hasSelected);
    const selectedCount = formik.values.executors.filter(
      (b) => b.isSelected
    ).length;
    if (selectedCount > 4) {
      setIsNextButtonEnabled(false);
    } else if (selectedCount >= 4) {
      setaddButtonDisable(true);
    } else {
      setaddButtonDisable(false);
    }
  }, [formik.values.executors]);

  useEffect(() => {
    formik.setValues({
      executors: executors.map((b) => ({
        id: b.beneficiary_id,
        executor_type: b.executor_type,
        isSelected: b.is_selected || false,
      })),
    });
  }, [executors]);

  const validationSchemaForGuardian = Yup.object().shape({
    beneficiary_first_name: Yup.string().required("Required field"),
    beneficiary_last_name: Yup.string().required("Required field"),
    beneficiary_email: Yup.string().email("Invalid email address"),
    beneficiary_dob: Yup.string()
      .nullable()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
        "Date of birth must be in dd/mm/yyyy format"
      )
      .test("is-past-date", "Date must be in the past", (value) => {
        if (!value) return true; // Skip if empty
        const [day, month, year] = value.split("/");
        const enteredDate = new Date(`${year}-${month}-${day}`);
        return enteredDate < new Date();
      })
      .test(
        "is-after-1900",
        "Please enter a date of birth after 1900",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          return parseInt(year) > 1900;
        }
      )
      .test(
        "is-over-18",
        "Sorry, but your executor needs to be over 18.",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          const enteredDate = new Date(`${year}-${month}-${day}`);
          const today = new Date();
          const age = today.getFullYear() - enteredDate.getFullYear();
          const isBirthdayPassed =
            today.getMonth() > enteredDate.getMonth() ||
            (today.getMonth() === enteredDate.getMonth() &&
              today.getDate() >= enteredDate.getDate());
          return age > 18 || (age === 18 && isBirthdayPassed);
        }
      ),
  });
  const formikAddGuardian = useFormik({
    initialValues: {
      beneficiary_first_name: "",
      beneficiary_last_name: "",
      beneficiary_email: "",
      beneficiary_dob: "",
      beneficiary_location: "",
    },
    validationSchema: validationSchemaForGuardian, // Apply validation schema
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      console.log("values  =>", values);
      // Convert "date_of_birth" from "dd/mm/yyyy" to "dob" with "dd-mm-yyyy"
      const transformedValues = {
        ...values,
        beneficiary_dob: values.beneficiary_dob
          ? formatDateToYMD(values.beneficiary_dob)
          : "", // Handle empty or invalid input
      };
      console.log("transformedValues  =>", transformedValues);
      // setRefreshBenficiary(false);
      AddExecutor(transformedValues)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            console.log("resss =>", res.data);

            const newExecutor = res.data;
            var data = {
              beneficiary_id: newExecutor.id,
              beneficiary_first_name: newExecutor.beneficiary_first_name,
              beneficiary_last_name: newExecutor.beneficiary_last_name,
              beneficiary_type: newExecutor.beneficiary_type,
              executor_type: "executor",
              guardiansOf: [],
              is_selected: true,
            };
            // Append new Executor to the list
            setExecutor((prev) => [...prev, data]);
            // Update Formik values
            formik.setFieldValue("executors", [
              ...formik.values.executors,
              {
                id: newExecutor.id,
                isSelected: false, // Default value for isSelected
                ...newExecutor, // Add other returned data
              },
            ]);
            toast.success("Executor Added Successfully");
            setOpenModal(false);
            resetForm(); // This will clear the form fields
          } else {
            if (res.status_code === "501") {
              toast.error(res.data.error);
            } else if (res.status_code === "422") {
              const errorMessages = Object.values(res.data.error)
                .flat()
                .join(", ");
              toast.error(errorMessages);
            }
          }
        })
        .catch((err) => {
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  return (
    <>
      {contentLoder ? (
        <Loader />
      ) : (
        <>
          <Toaster />
          <Header />
          <div>
            <div className="container">
              <div className="grid grid-cols-2 max-lg:grid-cols-1">
                <form onSubmit={formik.handleSubmit}>
                  <div className="mt-[15px]">
                    <div>
                      <h4 className="font-semibold text-[22px] sm:text-[24px] md:text-[26px] lg:text-[28px]">
                        Choose your executor
                      </h4>
                      <p className="text-[16px] text-slate-500">
                        It’s best to choose more than one executor. That way,
                        one of them can still act if the other isn’t able to.
                      </p>
                      <p className="text-[16px] text-slate-500">
                        You can choose up to four executors. Remember: having
                        lots of executors can make it harder to settle the
                        estate, as they have to work together.
                      </p>
                    </div>
                    <div className="text-[22px] sm:text-[24px] md:text-[26px] lg:text-[28px] font-bold mt-5">
                      <p>Select your executors</p>
                    </div>
                    {addButtonDisable && (
                      <div className="text-[18px] font-semibold mt-4 bg-[#f44336] text-white p-3 rounded">
                        You can select up to 4 Executor. Delete a Executor if
                        you would like to add another Executor.
                      </div>
                    )}
                    {executors.map((executor, index) => (
                      <div
                        className={`my-5 border-2 pb-3 px-4 GuardianDiv rounded ${
                          formik.values.executors[index]?.isSelected
                            ? "blueBorder"
                            : `border-[#d7d7d7] `
                        } 
                    `}
                        onClick={() => {
                          setExecutor((prevList) =>
                            prevList.map((executor, idx) =>
                              idx === index
                                ? {
                                    ...executor,
                                    is_selected: !executor.is_selected,
                                  }
                                : executor
                            )
                          );
                          formik.setFieldValue(
                            `executors[${index}].isSelected`,
                            !formik.values.executors[index]?.isSelected
                          );
                        }}
                        key={executor.id || index}
                      >
                        <div className="border-[#d7d7d7] rounded-lg">
                          <div className="flex items-center justify-between mt-[16px]">
                            <div className="flex items-center gap-5">
                              <div>
                                <img src="/assets/images/icon-mascot.png" />
                              </div>
                              <div>
                                <h4 className="text-[18px] text-black font-bold">
                                  {executor?.beneficiary_first_name}{" "}
                                  {executor?.beneficiary_last_name}
                                </h4>
                                <p>
                                  {executor.executor_type === "beneficiary" &&
                                  executor.guardiansOf.length
                                    ? `Guardian for: ${executor.guardiansOf
                                        .map(
                                          (guardian) =>
                                            `${guardian.child_or_pet_name}`
                                        )
                                        .join(", ")}`
                                    : executor.beneficiary_type  ? `Your ${executor.beneficiary_type}` : "Your willsguru"} 
                                </p>
                              </div>
                            </div>
                            <div>
                              <input
                                name={`executors[${index}].isSelected`}
                                type="checkbox"
                                className={`w-[20px] h-[20px]  ${
                                  addButtonDisable && !executor.is_selected
                                    ? "opacity-50 cursor-not-allowed"
                                    : ""
                                }`}
                                checked={
                                  formik.values.executors[index]?.isSelected ||
                                  false
                                }
                                onChange={(e) => {
                                  // e.stopPropagation(); // Prevent the parent div's onClick from firing
                                  formik.setFieldValue(
                                    `executors[${index}].isSelected`,
                                    e.target.checked
                                  );
                                }}
                                disabled={
                                  addButtonDisable && !executor.is_selected
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    <div className="my-5 border-b-2 pb-5">
                      <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                        <div className="flex items-center justify-between mt-[16px]">
                          <div className="flex items-center gap-5">
                            <div>
                              <img src="/assets/images/icon-mascot.png" />
                            </div>
                            <div>
                              <h4 className="text-[18px] text-black font-bold ">
                                Add a new executor
                              </h4> 
                              <p>Choose someone else to be an executor </p>
                            </div>
                          </div>
                          <div>
                            <Link>
                              <button
                                onClick={() => {
                                  setOpenModal(true);
                                }}
                                disabled={addButtonDisable}
                                className={`border-2 hover:bg-primary hover:text-white transition-all ease-out rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold  ${
                                  addButtonDisable
                                    ? "opacity-50 cursor-not-allowed"
                                    : ""
                                }`}
                              >
                                Add
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-between justify-end pb-5">
                      <div className="flex  pb-5">
                        <Link to={"/dashboard"}>
                          <button
                            type="button"
                            className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500"
                          >
                            <FaAngleLeft />
                            Back
                          </button>
                        </Link>
                      </div>
                      <div className="flex  pb-5">
                        {!loading ? (
                          <button
                            type="submit"
                            className={`bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-2 ${
                              isNextButtonEnabled
                                ? ""
                                : "opacity-50 cursor-not-allowed"
                            }`}
                            onClick={() => setLoading(true)}
                            disabled={!isNextButtonEnabled}
                          >
                            Finish{" "}
                          </button>
                        ) : (
                          <button className="bg-primary flex justify-center px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-2">
                            <Spinner />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
                <div>
                  <div className="max-lg:hidden bg-no-repeat ">
                    <div className="fixed top-[100px] w-[500px] right-[6%]">
                      <img src="/assets/images/7.png" alt="mascot" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            open={openModal}
            onClose={onCloseGuardianModel}
            center
            classNames={{
              modal: "rounded-[5px] p-5", // Add the rounded class here along with padding
            }}
          >
            <div className="px-5">
              <form onSubmit={formikAddGuardian.handleSubmit}>
                <div>
                  <div>
                    <h4 className="text-black font-bold text-[22px] sm:text-[24px] md:text-[26px] lg:text-[28px]">
                      Add a new executor
                    </h4>
                  </div>
                  <div className="grid grid-cols-2 gap-5 ">
                    <div className="mt-5 mb-4 ">
                      <FloatingLabelInput
                        label="First Name"
                        type="text"
                        id="first_name"
                        name="beneficiary_first_name"
                        value={formikAddGuardian.values.beneficiary_first_name}
                        onChange={formikAddGuardian.handleChange}
                        onBlur={formikAddGuardian.handleBlur}
                        error={
                          formikAddGuardian.touched.beneficiary_first_name &&
                          formikAddGuardian.errors.beneficiary_first_name
                        }
                      />
                    </div>

                    <div className="mt-5 mb-4 ">
                      <FloatingLabelInput
                        label="Last Name"
                        type="text"
                        id="last_name"
                        name="beneficiary_last_name"
                        value={formikAddGuardian.values.beneficiary_last_name}
                        onChange={formikAddGuardian.handleChange}
                        onBlur={formikAddGuardian.handleBlur}
                        error={
                          formikAddGuardian.touched.beneficiary_last_name &&
                          formikAddGuardian.errors.beneficiary_last_name
                        }
                      />
                    </div>
                  </div>
                  <div className="mt-1 mb-4 ">
                    <FloatingLabelInput
                      label="Email address (optional)"
                      type="text"
                      id="new_guardian_email"
                      name="beneficiary_email"
                      value={formikAddGuardian.values.beneficiary_email}
                      onChange={formikAddGuardian.handleChange}
                      onBlur={formikAddGuardian.handleBlur}
                      error={
                        formikAddGuardian.touched.beneficiary_email &&
                        formikAddGuardian.errors.beneficiary_email
                      }
                    />
                  </div>
                  <div className="w-full mt-5">
                    <div className="relative w-full border-2 h-[60px] flex items-center">
                      <MaskedInput
                        mask={[
                          /\d/,
                          /\d/,
                          "/",
                          /\d/,
                          /\d/,
                          "/",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                        placeholder={
                          isFocused || formikAddGuardian.values.beneficiary_dob
                            ? "dd/mm/yyyy"
                            : ""
                        }
                        pipe={autoCorrectedDatePipe}
                        value={formikAddGuardian.values.beneficiary_dob}
                        onFocus={() => setIsFocused(true)}
                        onBlur={(e) => {
                          setIsFocused(false);
                          formikAddGuardian.handleBlur(e); // To ensure Formik registers field as "touched"
                        }}
                        onChange={(e) => {
                          formikAddGuardian.setFieldValue(
                            "beneficiary_dob",
                            e.target.value
                          );
                        }}
                        className="block text-black w-full px-[20px] h-full appearance-none focus:outline-none focus:ring-0 peer border-red-500 focus:border-red-500"
                        name="beneficiary_dob"
                      />

                      <label
                        htmlFor="dob"
                        className="absolute left-5 top-[16px]  text-gray-500 transition-all duration-200 transform text-[10px] -translate-y-3.5 peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5"
                      >
                        Date of birth(optional)
                      </label>
                    </div>
                  </div>
                  {formikAddGuardian.touched.beneficiary_dob &&
                  formikAddGuardian.errors.beneficiary_dob ? (
                    <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                      <FaInfoCircle />
                      <p className="text-white py-1 px-2 text-sm my-2">
                        {formikAddGuardian.errors.beneficiary_dob}
                      </p>
                    </div>
                  ) : null}

                  <div>
                    <h4 className="text-[16px] text-black font-bold mt-[36px]">
                      Add their address
                    </h4>
                    <p className="text-slate-500 my-2">
                      Adding address is optional
                    </p>
                  </div>
                  <div className="mt-1 mb-4 ">
                    <FloatingLabelInput
                      label="Enter their full address"
                      type="text"
                      id="beneficiary_location"
                      name="beneficiary_location"
                      value={formikAddGuardian.values.beneficiary_location}
                      onChange={formikAddGuardian.handleChange}
                      onBlur={formikAddGuardian.handleBlur}
                    />
                  </div>
                  <div className="flex justify-between">
                    <div className="py-5 ">
                      {!loading ? (
                        <button
                          type="submit"
                          className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1"
                        >
                          Add Executor
                        </button>
                      ) : (
                        <button className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded">
                          <Spinner />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default Executor;
